import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/seo'

import { Container, Row, Col } from 'react-bootstrap'

class ThankYouPage extends React.Component {
	render() {
		const siteTitle = this.props.data.site.siteMetadata.title
		const siteDescription = this.props.data.site.siteMetadata.description

		return (
			<Layout location={this.props.location} title={siteTitle}>
				<Seo title={siteTitle} description={siteDescription} />
				<div id="hero">
					<Container>
						<Row>
							<Col>
									<div class="hero-content text-center">
									  <h1 class="hero-title">Thank You! We will get back to you as soon as possible!</h1>
									  <a href="/" className="btn btn-primary btn-sbt mt-3" type="submit">
									  	GO BACK TO HOME
									  </a>
									</div>
							</Col>
						</Row>
					</Container>
				</div>
			</Layout>
		)
	}
}

export default ThankYouPage

export const ThankYouQuery = graphql`
	query ThankYouQuery {
		site {
			siteMetadata {
				title
				author
				description
			}
		}
	}
`